import * as React from "react";
import type { SVGProps } from "react";
const SvgInnovate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="M42.716 29.138h-7.865v-7.865h-5.714v7.865h-7.864v5.724h7.864v7.855h5.714v-7.855h7.865v-5.724Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M28.281 20.417h7.427v7.865h7.864v7.436h-7.864v7.855H28.28v-7.855h-7.864v-7.436h7.864v-7.865Zm1.713 1.712v7.865h-7.865v4.012h7.865v7.855h4.001v-7.855h7.865v-4.012h-7.865V22.13h-4.001Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.019 6.25c-14.233 0-25.77 11.537-25.77 25.77 0 14.232 11.537 25.77 25.77 25.77 14.232 0 25.77-11.538 25.77-25.77 0-14.233-11.538-25.77-25.77-25.77ZM4.545 32.02c0-15.174 12.3-27.474 27.474-27.474 15.173 0 27.473 12.3 27.473 27.473 0 15.174-12.3 27.474-27.473 27.474-15.174 0-27.474-12.3-27.474-27.474Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M5.416 36.458a4.439 4.439 0 1 0 0-8.877 4.439 4.439 0 0 0 0 8.877Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M5.416 28.432a3.587 3.587 0 1 0 0 7.174 3.587 3.587 0 0 0 0-7.174ZM.126 32.02a5.29 5.29 0 1 1 10.58 0 5.29 5.29 0 0 1-10.58 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M58.583 36.458a4.439 4.439 0 1 0 0-8.877 4.439 4.439 0 0 0 0 8.877Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M58.582 28.432a3.587 3.587 0 1 0 0 7.174 3.587 3.587 0 0 0 0-7.174Zm-5.29 3.587a5.29 5.29 0 1 1 10.58 0 5.29 5.29 0 0 1-10.58 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M32.01 9.73a4.439 4.439 0 1 0 0-8.878 4.439 4.439 0 0 0 0 8.877Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.01 1.703a3.587 3.587 0 1 0 0 7.174 3.587 3.587 0 0 0 0-7.174ZM26.718 5.29a5.29 5.29 0 1 1 10.58 0 5.29 5.29 0 0 1-10.58 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M32.01 63.148a4.439 4.439 0 1 0 0-8.877 4.439 4.439 0 0 0 0 8.877Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.01 55.123a3.587 3.587 0 1 0 0 7.174 3.587 3.587 0 0 0 0-7.174Zm-5.291 3.587a5.29 5.29 0 1 1 10.58 0 5.29 5.29 0 0 1-10.58 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M18.654 13.301a4.439 4.439 0 1 0 0-8.877 4.439 4.439 0 0 0 0 8.877Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M18.654 5.276a3.587 3.587 0 1 0 0 7.173 3.587 3.587 0 0 0 0-7.173Zm-5.29 3.587a5.29 5.29 0 1 1 10.58 0 5.29 5.29 0 0 1-10.58 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M45.363 59.566a4.439 4.439 0 1 0 0-8.877 4.439 4.439 0 0 0 0 8.877Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M45.364 51.54a3.587 3.587 0 1 0 0 7.174 3.587 3.587 0 0 0 0-7.173Zm-5.29 3.587a5.29 5.29 0 1 1 10.58 0 5.29 5.29 0 0 1-10.58 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M8.872 23.084a4.439 4.439 0 1 0 0-8.877 4.439 4.439 0 0 0 0 8.877Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M8.871 15.058a3.587 3.587 0 1 0 0 7.174 3.587 3.587 0 0 0 0-7.174Zm-5.29 3.587a5.29 5.29 0 1 1 10.58 0 5.29 5.29 0 0 1-10.58 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M55.136 49.793a4.439 4.439 0 1 0 0-8.877 4.439 4.439 0 0 0 0 8.877Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M55.137 41.768a3.587 3.587 0 1 0 0 7.174 3.587 3.587 0 0 0 0-7.174Zm-5.29 3.587a5.29 5.29 0 1 1 10.58 0 5.29 5.29 0 0 1-10.58 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInnovate;
